import { DownOutlined, UserOutlined } from '@ant-design/icons';
import { Button, Dropdown, Modal } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { logout } from '../../redux/authSlice';
import { setLoginModal } from '../../redux/modalSlice';
import AWS_CONFIG, { ICON_FILE } from '../../constants/constants';

export const getIconUrl = (userId) => {
  return `${AWS_CONFIG.s3.staticHostUrl}/${AWS_CONFIG.s3.imgFolder}/${encodeURIComponent(
    userId,
  )}/${ICON_FILE}`;
};
const DropdownMenu = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);
  const reloadIcon = useSelector((state) => state.auth.reloadIcon);

  const [img, setImg] = useState();

  const fetchImage = async () => {
    if (user?.userId) {
      const iconUrl = getIconUrl(user.userId);

      const res = await fetch(iconUrl);
      // debug-console.log('fetch Image: res=', res);
      const imageBlob = await res.blob();
      // debug-console.log('fetch Image: imageBlob=', imageBlob);
      const imageObjectURL = URL.createObjectURL(imageBlob);
      setImg(imageObjectURL);
    }
  };

  const handleLogout = () => {
    Modal.confirm({
      title: 'Are you sure you want to logout?', //  CM001
      content: '',
      okText: 'Yes',
      cancelText: 'No',
      icon: null,
      centered: true,
      onOk() {
        dispatch(logout());
      },
      onCancel() {},
    });
  };

  const handleLogin = () => {
    // dispatch(logout());
    dispatch(setLoginModal(true));
  };

  useEffect(() => {
    try {
      fetchImage();
    } catch (err) {
      console.error('fetch error:', err);
    }
  }, [user, reloadIcon]);

  const items = [
    {
      key: '1',
      label: (
        <a
          className="profile-link"
          rel="noopener noreferrer"
          href="#"
          onClick={user?.userId ? handleLogout : handleLogin}
        >
          {user?.userId ? `Logout (${user.userId})` : 'Login'}
        </a>
      ),
    },
    // {
    //   key: '2',
    //   label: (
    //     <a target="_blank" rel="noopener noreferrer" href="#">
    //       2nd menu item (disabled)
    //     </a>
    //   ),
    //   icon: <SmileOutlined />,
    //   disabled: true,
    // },
  ];

  return (
    <Dropdown menu={{ items }}>
      <Button
        className="button-profile"
        onClick={(e) => e.preventDefault()}
        icon={<DownOutlined />}
        shape="round"
        size="large"
        type="ghost"
      >
        {/* <span>Profile</span> */}
        {img ? (
          <img alt={user?.name} src={img} style={{ marginLeft: '8px', marginTop: '-2px', height: '30px' }} />
        ) : (
          <>
            <span style={{ marginRight: '3px' }}>{user?.name}</span>
            <UserOutlined />
          </>
        )}
      </Button>
    </Dropdown>
  );
};

export default DropdownMenu;
